import api from "./api";

async function getCustomerGroups() {
  try {
    const response = await api.get("api/customerGroups");
    return response.data;
  } catch (error) {
    console.error(error);
    return [];
  }
}

async function getCustomerGroup(id) {
  try {
    const response = await api.get(`api/customerGroups/${id}`);
    return response.data;
  } catch (error) {
    console.error(error);
    return null;
  }
}

async function createCustomerGroup({ name }) {
  try {
    const response = await api.post("api/customerGroups", { name });
    return response.data;
  } catch (error) {
    console.error(error);
    return false;
  }
}

async function updateCustomerGroup(id, { name }) {
  try {
    const response = await api.put(`api/customerGroups/${id}`, { name });
    return response.data;
  } catch (error) {
    console.error(error);
    return false;
  }
}

async function deleteCustomerGroup(id) {
  try {
    const response = await api.delete(`api/customerGroups/${id}`);
    return response.status === 204;
  } catch (error) {
    console.error(error);
    return false;
  }
}

async function updateCustomerGroupMemberships(
  id,
  { customerIds, selectAll = false, excludeCustomerIds = [] },
) {
  try {
    const response = await api.put(`api/customerGroups/${id}/memberships`, {
      customerIds,
      selectAll,
      excludeCustomerIds,
    });
    return response.status === 204;
  } catch (error) {
    console.error(error);
    return false;
  }
}

export {
  getCustomerGroups,
  getCustomerGroup,
  createCustomerGroup,
  updateCustomerGroup,
  deleteCustomerGroup,
  updateCustomerGroupMemberships,
};
